var pad = require('./pad');

module.exports = function lpad(str, length, padStr) {
  return pad(str, length, padStr);
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/lpad.js
// module id = 1627
// module chunks = 0